import React from 'react';
import { WelmaLanding } from './pages/WelmaLanding';
export function App() {
  return <WelmaLanding data-id="element-0" />;
}